import React from 'react';
import { AlertCircle, Clock, BatteryWarning, HelpCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-100">
      <div className="container mx-auto px-4" data-id="element-101">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-103">
            Si enseñas Derecho, esto te va a sonar muy familiar…
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-104">
            Llegas cansado. Sabés que tenés que planificar. Abrís la
            computadora.
            <span className="block font-bold text-slate-800 mt-2" data-id="element-105">
              Y una vez más empezás desde cero.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-5xl mx-auto" data-id="element-106">
          <div className="space-y-8" data-id="element-107">
            <div className="bg-amber-50 p-6 rounded-xl shadow-sm border border-amber-100" data-id="element-108">
              <div className="flex items-start gap-4" data-id="element-109">
                <div className="bg-red-100 p-3 rounded-lg" data-id="element-110">
                  <AlertCircle className="h-6 w-6 text-red-600" data-id="element-111" />
                </div>
                <div data-id="element-112">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-113">
                    La noche anterior
                  </h3>
                  <p className="text-slate-600" data-id="element-114">
                    Cuadernos abiertos. Planificaciones a medias. Y esa frase
                    que vuelve siempre: "¿Qué doy mañana?"
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 p-6 rounded-xl shadow-sm border border-amber-100" data-id="element-115">
              <div className="flex items-start gap-4" data-id="element-116">
                <div className="bg-orange-100 p-3 rounded-lg" data-id="element-117">
                  <BatteryWarning className="h-6 w-6 text-orange-600" data-id="element-118" />
                </div>
                <div data-id="element-119">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-120">
                    Clases que no conectan
                  </h3>
                  <p className="text-slate-600" data-id="element-121">
                    El contenido está, pero los alumnos no participan. No
                    preguntan. No opinan. No discuten.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 p-6 rounded-xl shadow-sm border border-amber-100" data-id="element-122">
              <div className="flex items-start gap-4" data-id="element-123">
                <div className="bg-blue-100 p-3 rounded-lg" data-id="element-124">
                  <Clock className="h-6 w-6 text-blue-900" data-id="element-125" />
                </div>
                <div data-id="element-126">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-127">
                    Falta de tiempo crónica
                  </h3>
                  <p className="text-slate-600" data-id="element-128">
                    Planificar compite con correcciones, reuniones, familia y
                    vida. Nunca alcanza el tiempo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-900 text-amber-50 p-8 md:p-10 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-129">
            <div className="relative z-10" data-id="element-130">
              <h3 className="text-2xl font-bold mb-6 text-amber-400" data-id="element-131">
                El verdadero problema
              </h3>
              <p className="text-lg mb-6 leading-relaxed" data-id="element-132">
                Nadie te dio un sistema completo para enseñar Derecho:
              </p>
              <ul className="space-y-4 mb-8" data-id="element-133">
                <li className="flex items-center gap-3" data-id="element-134">
                  <div className="w-2 h-2 bg-amber-400 rounded-full" data-id="element-135"></div>
                  <span data-id="element-136">En el nivel secundario argentino</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-137">
                  <div className="w-2 h-2 bg-amber-400 rounded-full" data-id="element-138"></div>
                  <span data-id="element-139">Con adolescentes reales</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-140">
                  <div className="w-2 h-2 bg-amber-400 rounded-full" data-id="element-141"></div>
                  <span data-id="element-142">Para todo el ciclo lectivo</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-143">
                  <div className="w-2 h-2 bg-amber-400 rounded-full" data-id="element-144"></div>
                  <span data-id="element-145">Con el tiempo real que tiene un docente</span>
                </li>
              </ul>
              <p className="italic text-amber-200 border-l-4 border-blue-800 pl-4" data-id="element-146">
                "Así se vive el problema: entrás tenso, improvisás, salís
                agotado… y el ciclo se repite."
              </p>
            </div>

            {/* Decorative background elements */}
            <HelpCircle className="absolute -bottom-10 -right-10 w-64 h-64 text-blue-800 opacity-20" data-id="element-147" />
          </div>
        </div>
      </div>
    </section>;
}